import { gql } from '@utils/gpl-dedup';
import { listItemFragment } from '@graphql/listItems/fragments';

export const createListItem = gql`
  mutation createListItem (
    $input: ListItemInput!
  ) {
    createListItem(
      input: $input
    ) {
      id
      ...listItem
    }
  }
  ${listItemFragment}
`;
